import { ContactSlugEnum } from '@systemeio/ui'
import { InitFieldsInterface } from 'modules/stores/store/components/contact-fields'

export const physicalProductInitFields: InitFieldsInterface[] = [
  { slug: ContactSlugEnum.Email, mandatory: true, required: true },
  { slug: ContactSlugEnum.FirstName, mandatory: true, required: true },
  { slug: ContactSlugEnum.Surname, mandatory: true, required: true },
  { slug: ContactSlugEnum.StreetAddress, mandatory: true, required: true },
  { slug: ContactSlugEnum.City, mandatory: true, required: true },
  { slug: ContactSlugEnum.Postcode, mandatory: true, required: true },
  { slug: ContactSlugEnum.Country, mandatory: true, required: true },
  { slug: ContactSlugEnum.PhoneNumber, mandatory: true, required: true },
]
